export default {
  assetsPercentage(state) {
    const assetsLoaded = state.assets.loaded.filter(asset => state.assets.toLoad.includes(asset));
    return Math.ceil((assetsLoaded.length / state.assets.toLoad.length) * 100);
  },
  assetsAreReady(state, getters) {
    return getters.assetsPercentage === 100;
  }
};
